/* Brand shimmer skeletons */
export function Skel({ h = 16, w = "100%", r = 8, className = "" }) {
  return <span className={`lux-skel ${className}`} style={{ height: h, width: w, borderRadius: r }} aria-hidden="true" />;
}

export function SkelCard({ lines = 3 }) {
  return (
    <div className="lux-skel-card glass-card" data-testid="skeleton-card">
      <Skel h={120} r={12} />
      {Array.from({ length: lines }).map((_, i) => <Skel key={i} h={12} w={`${90 - i * 18}%`} />)}
    </div>
  );
}

export default Skel;
